import {
  Toast,
  MessageBox,
  Indicator,
} from 'mint-ui';

// 自定义toast
export function CusToast(msg, duration = 2500) {
  return Toast({
    message: msg,
    duration: duration,
    className: 'index-9999',
  });
}

// 自定义Alert
export function CusAlert(msg = '', ok = null) {
  return MessageBox.alert(`<div style='font-size:0.85rem;line-height:1.5;text-align:center;'>${msg}</div>`, {
    title: '提示',
    confirmButtonText: '确定',
    confirmButtonClass: 'mint-confirm-confirm-btn',
  })
    .then(() => ok && ok());
}

// 自定义confirm
export function CusConfirm(msg = '', ok = null, no = null) {
  return MessageBox.confirm(`<div style='font-size:0.85rem;line-height:1.5;text-align:center;'>${msg}</div>`, {
    title: '提示',
    confirmButtonText: '确定',
    confirmButtonClass: 'mint-confirm-confirm-btn',
    cancelButtonText: '取消',
    cancelButtonClass: 'mint-confirm-cancel-btn',
  })
    .then(action => {
      if (action === 'confirm') {
        ok && ok();
      }
    })
    .catch(error => {
      if (error === 'cancel') {
        no && no();
      }
    });
}

// 自定义打开loading
export function CusLoadingOpen(msg = '加载中…') {
  Indicator.open({
    text: msg,
    spinnerType: 'fading-circle',
  });
}

// 自定义关闭loading
export function CusLoadingClose() {
  Indicator.close();
}
